import { isRichTextValueConsideredEmpty } from "@uniformdev/richtext";

import { BottomCallToAction } from "@/libraries/design/patterns";
import { RichTextComponent } from "@/libraries/design/utils";

import type { RichTextNode } from "@uniformdev/richtext";

export interface UniformCallToActionProps {
    title: { root: RichTextNode };
    emphasisColor?: string;
    body?: { root: RichTextNode };
    buttonLabel?: string;
    buttonHref?: string;
}

const UniformCallToAction = (props: UniformCallToActionProps) => {
    return (
        <BottomCallToAction
            title={
                <RichTextComponent
                    uniformRichText={{
                        type: "root",
                        version: 1,
                        children: props.title.root.children?.at(0)?.children
                    }}
                />
            }
            emphasisColor={props.emphasisColor}
            body={
                !isRichTextValueConsideredEmpty(props.body) ? (
                    <RichTextComponent uniformParameter="body" />
                ) : undefined
            }
            button={
                props.buttonLabel && props.buttonHref
                    ? {
                          buttonHref: props.buttonHref,
                          buttonLabel: props.buttonLabel,
                          dataEventProps: {
                              "data-product-key": "uniform",
                              "data-event-component": "linkButton",
                              "data-event-container": "ctaSection",
                              "data-event": "clicked"
                          }
                      }
                    : undefined
            }
        />
    );
};

export default UniformCallToAction;
